import { useRef, useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./section4.css";

import EmailIcon from "../../assets/images/email-branco.png";
import WhatsappIcon from "../../assets/images/whatsapp-branco.png";
import MarcadorIcon from "../../assets/images/marcador-branco.png";

function Section4() {
  const formRef = useRef();

  const [whatsappValue, setWhatsappValue] = useState("");
  const [lgpdAceito, setLgpdAceito] = useState(false);
  const [faqAberto, setFaqAberto] = useState(null);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  const handleWhatsappChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > 11) value = value.slice(0, 11);

    if (value.length > 10) {
      value = value.replace(/^(\d{2})(\d{5})(\d{4}).*/, "($1) $2-$3");
    } else if (value.length > 6) {
      value = value.replace(/^(\d{2})(\d{4})(\d{4}).*/, "($1) $2-$3");
    } else if (value.length > 2) {
      value = value.replace(/^(\d{2})(\d*)/, "($1) $2");
    } else if (value.length > 0) {
      value = value.replace(/^(\d*)/, "($1");
    }

    setWhatsappValue(value);
  };

  const validarFormulario = (dados) => {
    const { nome, email, whatsapp, mensagem } = dados;
    const whatsappLimpo = whatsapp.replace(/\D/g, "");
    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!nome || nome.trim().length <= 1) {
      toast.error("Por favor, insira um nome válido (mínimo 2 caracteres).");
      return false;
    }

    if (whatsappLimpo.length < 10 || whatsappLimpo.length > 11) {
      toast.error("O WhatsApp deve ter 10 (fixo) ou 11 (celular) dígitos.");
      return false;
    }

    if (!regexEmail.test(email)) {
      toast.error("Por favor, insira um e-mail válido.");
      return false;
    }

    if (!mensagem || mensagem.trim().length <= 1) {
      toast.error("A mensagem é muito curta.");
      return false;
    }

    if (!lgpdAceito) {
      toast.error(
        "É necessário concordar com a Política de Privacidade para enviar.",
      );
      return false;
    }

    return true;
  };

  const enviarEmail = (e) => {
    e.preventDefault();

    const formData = new FormData(formRef.current);
    const dados = Object.fromEntries(formData.entries());

    if (!validarFormulario(dados)) return;

    const templateParams = {
      nome: dados.nome,
      email: dados.email,
      whatsapp: dados.whatsapp.replace(/\D/g, ""),
      mensagem: dados.mensagem,
    };

    const idCarga = toast.loading("Enviando mensagem...");

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
      )
      .then(
        () => {
          toast.update(idCarga, {
            render:
              "Mensagem enviada com sucesso! Entraremos em contato em breve.",
            type: "success",
            isLoading: false,
            autoClose: 5000,
          });
          formRef.current.reset();
          setWhatsappValue("");
          setLgpdAceito(false);
        },
        (error) => {
          console.error(error);
          toast.update(idCarga, {
            render: "Erro ao enviar mensagem. Tente diretamente pelo WhatsApp.",
            type: "error",
            isLoading: false,
            autoClose: 5000,
          });
        },
      );
  };

  const toggleFaq = (index) => {
    setFaqAberto(faqAberto === index ? null : index);
  };

  const faqs = [
    {
      pergunta: "Como funciona a consulta jurídica inicial?",
      resposta:
        "O atendimento inicial pode ser realizado presencialmente em nosso escritório em São Paulo ou 100% online por videoconferência e WhatsApp. Avaliamos detalhadamente a sua demanda para traçar a melhor estratégia jurídica.",
    },
    {
      pergunta: "O escritório atende clientes fora de São Paulo?",
      resposta:
        "Sim. O escritório Antonio Saldanha Advocacia possui estrutura digital preparada para atuar em todo o território nacional, acompanhando processos eletrônicos e audiências virtuais com total eficiência.",
    },
    {
      pergunta: "Quais documentos preciso apresentar na primeira reunião?",
      resposta:
        "Varia conforme a área do Direito. De forma geral, recomendamos ter em mãos seu documento oficial com foto (RG/CPF ou CNH), comprovante de residência e os documentos específicos relacionados ao seu caso (contratos, recibos, notificações ou extratos).",
    },
    {
      pergunta: "Como poderei acompanhar o andamento do meu caso?",
      resposta:
        "Prezamos pela transparência total. Nossa equipe fornece atualizações periódicas por WhatsApp, e-mail e reuniões de alinhamento sempre que houver desdobramentos relevantes no processo.",
    },
  ];

  return (
    <section className="container-fluid mt-5 px-2 px-md-4 px-xl-5 section4">
      <ToastContainer position="top-right" autoClose={4000} />

      <div className="section4-wrapper">
        <div className="text-center mb-4">
          <h2 className="titulos-secoes" data-aos="fade-up">
            Fale Conosco
          </h2>
        </div>

        {/* Card de Contato & Formulário */}
        <div
          className="card border-0 rounded-3 shadow-lg overflow-hidden div-fale-conosco mb-5"
          data-aos="fade-up"
        >
          <div className="row g-0">
            {/* Informações Institucionais / NAP */}
            <div className="col-12 col-lg-5 col-info-contato p-4 p-md-5 d-flex flex-column justify-content-between">
              <div>
                <span className="badge badge-dourado mb-3">
                  Atendimento Humanizado
                </span>
                <h3 className="fs-3 fw-bold text-white mb-4">
                  Entre em Contato
                </h3>

                <div className="info-item mb-4 align-items-center">
                  <div className="info-icon-wrapper">
                    <img
                      src={EmailIcon}
                      alt="Ícone de E-mail"
                      width="26"
                      height="26"
                    />
                  </div>
                  <div>
                    <span className="d-block text-dourado font-xs text-uppercase fw-bold letter-spacing-1 mb-1">
                      E-mail Oficial
                    </span>
                    <a
                      href="mailto:saldanha.advocacia01@gmail.com"
                      className="text-white text-decoration-none font-sm fw-medium info-link"
                    >
                      saldanha.advocacia01@gmail.com
                    </a>
                  </div>
                </div>

                <div className="info-item mb-4 align-items-center">
                  <div className="info-icon-wrapper">
                    <img
                      src={WhatsappIcon}
                      alt="Ícone do WhatsApp"
                      width="26"
                      height="26"
                    />
                  </div>
                  <div>
                    <span className="d-block text-dourado font-xs text-uppercase fw-bold letter-spacing-1 mb-1">
                      WhatsApp & Telefone
                    </span>
                    <a
                      href="https://wa.me/5511954242066"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white text-decoration-none font-sm fw-medium info-link"
                    >
                      +55 (11) 95424-2066
                    </a>
                  </div>
                </div>

                <div className="info-item mb-4 align-items-center">
                  <div className="info-icon-wrapper">
                    <img
                      src={MarcadorIcon}
                      alt="Ícone de Localização"
                      width="26"
                      height="26"
                    />
                  </div>
                  <div>
                    <span className="d-block text-dourado font-xs text-uppercase fw-bold letter-spacing-1 mb-1">
                      Nosso Endereço
                    </span>
                    <p className="text-white mb-0 font-sm fw-medium">
                      R. Manuel Borba, 257 - Conj. 35 - Santo Amaro, São Paulo -
                      SP
                    </p>
                  </div>
                </div>
              </div>

              <div className="pt-4 border-top border-secondary">
                <a
                  href="https://wa.me/5511954242066"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn botao-dourado w-100 py-3 shadow"
                >
                  Atendimento Imediato pelo WhatsApp
                </a>
              </div>
            </div>

            {/* Formulário de Mensagem */}
            <div className="col-12 col-lg-7 p-4 p-md-5 bg-white">
              <h3 className="fs-4 fw-bold text-dark mb-4">
                Envie uma Mensagem Direta
              </h3>

              <form
                ref={formRef}
                onSubmit={enviarEmail}
                className="d-flex flex-column gap-3"
              >
                <div>
                  <label
                    htmlFor="nome"
                    className="form-label font-sm fw-semibold text-dark mb-1"
                  >
                    Nome Completo *
                  </label>
                  <input
                    type="text"
                    id="nome"
                    name="nome"
                    required
                    className="form-control input-personalizado"
                    placeholder="Seu nome completo"
                  />
                </div>

                <div className="row g-3">
                  <div className="col-12 col-md-6">
                    <label
                      htmlFor="whatsapp"
                      className="form-label font-sm fw-semibold text-dark mb-1"
                    >
                      WhatsApp (com DDD) *
                    </label>
                    <input
                      type="tel"
                      id="whatsapp"
                      name="whatsapp"
                      required
                      className="form-control input-personalizado"
                      placeholder="(11) 99999-9999"
                      value={whatsappValue}
                      onChange={handleWhatsappChange}
                    />
                  </div>

                  <div className="col-12 col-md-6">
                    <label
                      htmlFor="email"
                      className="form-label font-sm fw-semibold text-dark mb-1"
                    >
                      E-mail *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      className="form-control input-personalizado"
                      placeholder="seuemail@exemplo.com"
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="mensagem"
                    className="form-label font-sm fw-semibold text-dark mb-1"
                  >
                    Como podemos ajudar você? *
                  </label>
                  <textarea
                    id="mensagem"
                    name="mensagem"
                    required
                    className="form-control input-personalizado textarea-personalizada"
                    placeholder="Descreva resumidamente seu caso ou dúvida jurídica..."
                    rows="4"
                  />
                </div>

                <div className="form-check my-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="consentimentoLgpd"
                    checked={lgpdAceito}
                    onChange={(e) => setLgpdAceito(e.target.checked)}
                  />
                  <label
                    className="form-check-label font-xs text-muted"
                    htmlFor="consentimentoLgpd"
                  >
                    Li e concordo com a Política de Privacidade e com o uso dos
                    meus dados para contato.
                  </label>
                </div>

                <button
                  type="submit"
                  className="btn botao-escuro-padrao w-100 py-3 shadow"
                >
                  Enviar mensagem
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Seção FAQ Institucional & Jurídico */}
        <div className="my-5 py-4" data-aos="fade-up">
          <div className="text-center mb-4">
            <span className="badge badge-dourado mb-2">
              Esclarecimentos Rápidos
            </span>
            <h3 className="fs-3 fw-bold text-dark">Perguntas Frequentes</h3>
          </div>

          <div className="accordion-custom max-w-900 mx-auto">
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                className="faq-item border rounded-3 mb-3 bg-white overflow-hidden shadow-sm"
              >
                <button
                  type="button"
                  className="faq-question w-100 text-start p-3 p-md-4 d-flex justify-content-between align-items-center border-0 bg-transparent fw-semibold text-dark"
                  onClick={() => toggleFaq(idx)}
                  aria-expanded={faqAberto === idx}
                >
                  <span>{faq.pergunta}</span>
                  <span
                    className={`faq-icon ${faqAberto === idx ? "rotate" : ""}`}
                  >
                    <svg
                      width="20"
                      height="20"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </span>
                </button>
                {faqAberto === idx && (
                  <div className="faq-answer p-3 p-md-4 pt-0 text-secondary font-sm border-top">
                    {faq.resposta}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Localização / Mapa SEO Local */}
        <div className="my-5" data-aos="fade-up">
          <div className="text-center mb-4">
            <h3 className="fs-3 fw-bold text-dark">Nossa Localização</h3>
            <p className="text-muted font-sm">
              R. Manuel Borba, 257 - Conj. 35 - Santo Amaro, São Paulo - SP
            </p>
          </div>

          <div className="mapa-container rounded-3 overflow-hidden shadow-lg border">
            <iframe
              title="Mapa de Localização do Escritório Antonio Saldanha Advocacia em Santo Amaro, São Paulo"
              src="https://www.google.com/maps?q=R.%20Manuel%20Borba%2C%20257%20-%20Conj.%2035%20-%20Santo%20Amaro%2C%20S%C3%A3o%20Paulo%20-%20SP&output=embed"
              width="100%"
              height="350"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Section4;
